import { StoreTapAndGo, StoreTapAndGoListItem } from '../../core';

export interface IStoreTapAndGo extends StoreTapAndGo {
    ShoppingFlows: IShoppingFlows;
    ShoppingScanMethod: EShoppingScanMethod;
    selectedScanAction: any;
    PayOutsideJispEnabled: boolean;
    CarrierBagEnabled: boolean;
}

export interface IStoreTapAndGoListItem extends StoreTapAndGoListItem {
    isOpenEdit: boolean;
    ShoppingFlows: IShoppingFlows;
    AddressLine1: string;
    ShoppingScanMethod: EShoppingScanMethod;
    PayOutsideJispEnabled: boolean;
    CarrierBagEnabled: boolean;
}

export interface IStickerItem {
    ID: number;
    Code: string;
    error: string;
}

export interface IShoppingFlows {
    JispGoOrPreOrder: IShoppingFlow;
    InStore: IShoppingFlow;
    ClickCollect: IShoppingFlow;
    Delivery: IShoppingFlow;
}

export interface ISellerShoppingFlows {
    JispGoOrPreOrder: boolean;
    InStore: boolean;
    ClickCollect: boolean;
    Delivery: boolean;
}

export interface IShoppingFlow {
    Available: boolean;
    Enabled: boolean;
}

export enum EShoppingScanMethod {
    NFC = 1,
    BARCODE = 2
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/tapAndGo/models/index.ts